var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgSpinner = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    preserveAspectRatio: "xMidYMid",
    className: "lds-eclipse",
    style: {
      background: "none"
    },
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "ng-attr-d": "{{config.pathCmd}}",
    "ng-attr-fill": "{{config.color}}",
    stroke: "none",
    d: "M10 50A40 40 0 0 0 90 50A40 42 0 0 1 10 50",
    transform: "rotate(143.699 50 51)"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    calcMode: "linear",
    values: "0 50 51;360 50 51",
    keyTimes: "0;1",
    dur: "1s",
    begin: "0s",
    repeatCount: "indefinite"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSpinner, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/spinner.3a9928fe.svg";
export { ForwardRef as ReactComponent };